import bdPasswordStrength from 'bd-password-strength';
import { find } from 'lodash';

import templateHtml from './password-strength-indicator.html';

const component = {};

component.template = templateHtml;

component.bindings = {
    password: '<',
    onPasswordStrengthChange: '&',
    isHaveIBeenPwnedServiceEnabled: '<'
};

component.controllerAs = 'vm';

function PasswordStrengthIndicatorController(
    BdLocalize,
    PASSWORD_STRENGTH_BOUNDS
) {
    const vm = this;

    vm.passwordStrengthValues = {
        notAvailable: {
            result: 0,
            text: BdLocalize.getString('Global.Component.Settings.Security.Password.PasswordStrengthIndicator.NotAvailable', 'N/A'),
            minValue: 0,
            maxValue: 0,
            cssClass: 'password-strength-indicator__progress-bar--weak'
        },
        weak: {
            result: 25,
            text: BdLocalize.getString('Global.Component.Settings.Security.Password.PasswordStrengthIndicator.Weak', 'Weak'),
            minValue: PASSWORD_STRENGTH_BOUNDS.Weak.minValue,
            maxValue: PASSWORD_STRENGTH_BOUNDS.Weak.maxValue,
            cssClass: 'password-strength-indicator__progress-bar--weak'
        },
        moderate: {
            result: 50,
            text: BdLocalize.getString('Global.Component.Settings.Security.Password.PasswordStrengthIndicator.Moderate', 'Moderate'),
            minValue: PASSWORD_STRENGTH_BOUNDS.Moderate.minValue,
            maxValue: PASSWORD_STRENGTH_BOUNDS.Moderate.maxValue,
            cssClass: 'password-strength-indicator__progress-bar--moderate'
        },
        strong: {
            result: 75,
            text: BdLocalize.getString('Global.Component.Settings.Security.Password.PasswordStrengthIndicator.Strong', 'Strong'),
            minValue: PASSWORD_STRENGTH_BOUNDS.Strong.minValue,
            maxValue: PASSWORD_STRENGTH_BOUNDS.Strong.maxValue,
            cssClass: 'password-strength-indicator__progress-bar--strong'
        },
        veryStrong: {
            result: 100,
            text: BdLocalize.getString('Global.Component.Settings.Security.Password.PasswordStrengthIndicator.VeryStrong', 'Very strong'),
            minValue: PASSWORD_STRENGTH_BOUNDS.VeryStrong.minValue,
            maxValue: PASSWORD_STRENGTH_BOUNDS.VeryStrong.maxValue,
            cssClass: 'password-strength-indicator__progress-bar--very-strong'
        }
    };
    
    vm.passwordStrengthResult = vm.passwordStrengthValues.notAvailable;

    function getPasswordStrengthResult(passwordStrength) {
        if (passwordStrength <= vm.passwordStrengthValues.notAvailable.minValue) {
            return vm.passwordStrengthValues.notAvailable;
        }

        return find(vm.passwordStrengthValues, strengthValue => {
            return strengthValue.minValue <= passwordStrength && strengthValue.maxValue > passwordStrength;
        });
    }

    vm.$onChanges = function onChanges(changes) {
        // Recalculate every time the password changes.
        if (changes.password) {
            // If the password is null or undefined, make it an empty string.
            const password = changes.password.currentValue || '';
            const passwordStrength = password.length >= 8 || password.length === 0 ? bdPasswordStrength.calculatePasswordStrength(password, vm.isHaveIBeenPwnedServiceEnabled) : 1;
            vm.passwordStrengthResult = getPasswordStrengthResult(passwordStrength);
            const isPasswordStrongEnough = password.length > 0 && vm.passwordStrengthResult.result >= vm.passwordStrengthValues.strong.result;
            vm.onPasswordStrengthChange({isPasswordStrongEnough});
        }
    };
}

PasswordStrengthIndicatorController.$inject = [
    'BdLocalize',
    'PASSWORD_STRENGTH_BOUNDS'
];
component.controller = PasswordStrengthIndicatorController;
export const PasswordStrengthIndicatorComponent = component;
